module.exports = __webpack_public_path__ + "img/client-logos.ed43e4d0.png";